import axios from "axios"
import Swal from "sweetalert2"
import router from "../../router"
export default {
  namespaced: true,
  state: {
    token: "",
    users: {},
  },
  mutations: {
    SET_USERS(state, user) {
      state.users = user
    },
  },
  actions: {
    change_password({}, payload) {
      console.log(payload)
      this.state.Global.loader = true
      axios
        .post("user/change-password", payload, {
          headers: {
            Authorization: "Bearer " + this.state.Auth.token,
          },
        })
        .then((res) => {
          Swal.fire("Berhasil", res.data.message, "success")
          this.state.Global.loader = false
          router.push({ name: "Setting" })
        })
        .catch((err) => {
          console.log(err.response)
          if (err.response.data.new_confirm_password) {
            Swal.fire(
              "Gagal",
              err.response.data.new_confirm_password[0],
              "error"
            )
          } else if (err.response.data.current_password) {
            Swal.fire("Gagal", err.response.data.current_password[0], "error")
          } else if (err.response.data.new_password) {
            Swal.fire("Gagal", err.response.data.new_password[0], "error")
          } else {
            Swal.fire("Gagal", "Sedang Terjadi Kesalahan", "error")
          }
          this.state.Global.loader = false
        })
    },
    change_photo({}, payload) {
      console.log(payload)
      this.state.Global.loader = true
      axios
        .post("user/profile-photo/submit", payload, {
          headers: {
            Authorization: "Bearer " + this.state.Auth.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            this.state.Global.loaderBar = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
          },
        })
        .then((res) => {
          this.state.Global.loaderBar = 0
          Swal.fire("Berhasil", res.data.message, "success")
          this.state.Global.loader = false
          router.push({ name: "Setting" })
        })
        .catch((err) => {
          this.state.Global.loaderBar = 0
          console.log(err.response)
          if (err.response.data.profile_picture) {
            Swal.fire("Gagal", err.response.data.profile_picture[0], "error")
          } else {
            Swal.fire("Gagal", "Sedang Terjadi Kesalahan", "error")
          }
          this.state.Global.loader = false
        })
    },
    async getUser({ commit }, payload) {
      this.state.Global.loader = true
      let response = await axios.get("users")
      if (response) {
        var data = response.data.data
        this.state.Global.loader = false
        commit("SET_USERS", data)
      } else {
        this.state.Global.loader = false
      }
    },
  },
  getters: {
    users(state) {
      return state.users
    },
  },
}
